import { render, staticRenderFns } from "./IndicatorsSelection.vue?vue&type=template&id=fca7c988&"
import script from "./IndicatorsSelection.vue?vue&type=script&lang=js&"
export * from "./IndicatorsSelection.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsSelection.vue?vue&type=style&index=0&id=fca7c988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports